export default {
  user: null,
  releases: null,
  tags: {},
  notes: {},
  progresses: {},
  dragging: false,
  activeListIndex: null,
  gameLists: {},
  settings: null,
  platform: null,
  results: null,
  galleryOpen: false,
  games: {},
  publicGameData: {},
  game: null,
  wallpaperUrl: null,
};



// WEBPACK FOOTER //
// ./src/store/state.js